module.exports = __webpack_public_path__ + "img/icon-arrow-right-b.4134d4d4.svg";